import { Component, Input } from '@angular/core';
import { Timeslot } from '~/core/model/timeslot.model';
@Component({
  selector: 'app-timeslot-price-preview',
  templateUrl: './timeslot-price-preview.component.html',
})
export class TimeslotPricePreviewComponent {
  @Input() public timeslot: Timeslot;
}
